import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FacilityDobryAgentService } from '../../services/facility-dobry-agent.service';
import { DobryAgentInsuranceCompany } from '../../interface/facility-dobry-agent';

@Component({
  selector: 'app-insurance-company-dobry-agent-select',
  templateUrl: './insurance-company-dobry-agent-select.component.html',
  styleUrls: ['./insurance-company-dobry-agent-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InsuranceCompanyDobryAgentSelectComponent),
      multi: true,
    },
  ],
})
export class InsuranceCompanyDobryAgentSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() label = 'Towarzystwa ubezpieczeniowe';
  @Input() placeholder = 'Wybierz towarzystwa';
  @Input() multiple = true;
  @Input() required = false;

  items: DobryAgentInsuranceCompany[] = [];
  filteredItems: DobryAgentInsuranceCompany[] = [];

  value: string | string[] | null = [];
  disabled = false;

  private onChange: (value: string | string[] | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(
    private facilityDobryAgentService: FacilityDobryAgentService,
  ) {}

  ngOnInit(): void {
    this.facilityDobryAgentService.getInsuranceCompanyDobryAgentSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((items: DobryAgentInsuranceCompany[]) => {
        this.items = (items ?? [])
          .filter((item) => item.active)
          .filter((item) => !item.deleted);

        this.filteredItems = this.items;
      });
  }

  writeValue(value: string | string[] | null): void {
    this.value = value ?? (this.multiple ? [] : null);
  }

  registerOnChange(fn: (value: string | string[] | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  changeValue(value: string | string[] | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  compareByUuid(a: string | DobryAgentInsuranceCompany, b: string | DobryAgentInsuranceCompany): boolean {
    const first = typeof a === 'object' ? a?.uuid : a;
    const second = typeof b === 'object' ? b?.uuid : b;

    return first === second;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
